var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"fill-height"},[_c('v-col',{staticClass:"fill-height"},[_c('MapChart',{attrs:{"countryData":{ US: 50, CA: 7, GB: 8, VE: 14, ES: 14  },"highColor":"#4656ff","lowColor":"#f4f778","countryStrokeColor":"#c1c2cf","defaultCountryFillColor":"#c1c2cf"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }